import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '~/javascript/components/users/user.vue'

export default class extends Controller {
  static values = {
    user: Object
  }

  connect() {
    const props = {
      user: this.userValue
    }

    this.vue = createApp(App, props)
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
